import React from 'react';
import Footer from '../components/Footer';
import SEOHead from '../seo/SEOHead';
import { PAGE_SEO } from '../seo/seoConfig';

const ReturnsExchangePage = () => {
  return (
    <>
    <SEOHead
      title={PAGE_SEO.returns.title}
      description={PAGE_SEO.returns.description}
      keywords={PAGE_SEO.returns.keywords}
      canonical={PAGE_SEO.returns.canonical}
      ogImage={PAGE_SEO.returns.ogImage}
    />
    <div className="returns-container">
      <div className="returns-content">
        <h1 className="returns-heading">Returns and Exchange</h1>
        <p className="returns-text">
          We are committed to ensuring full customer satisfaction with respect to the products. However, if you are not happy with the product and choose to return the order, please contact us on <a href="tel:+917310777481" className="phone-link">+91 73107 77481</a>
        </p>
        
        <h1 className="returns-heading cancellation-heading">Cancellation By Customers</h1>
        <p className="returns-text">
          You can opt for cancellation and once the cancellation request is received, we will initiate the process of refunding the amount to your account via the same payment mode that you had used to make the transaction.
        </p>
      </div>
      
      <style>{`
        .returns-container {
          width: 100%;
          max-width: var(--max-width);
          margin: 0 auto;
          padding: 0 var(--left-right-padding);
        }
        
        .returns-content {
          margin: var(--spacing-5) 0;
        }
        
        .returns-heading {
          font-family: var(--font-family-primary);
          font-size: var(--font-size-4);
          font-weight: var(--font-weight-2);
          margin-bottom: var(--spacing-2);
          color: var(--color-1);
        }
        
        .cancellation-heading {
          margin-top: var(--spacing-5);
        }
        
        .returns-text {
          font-family: var(--font-family-tertiary);
          font-size: var(--font-size-2);
          line-height: 1.5;
          margin-bottom: var(--spacing-3);
        }
        
        .phone-link {
          color: var(--color-3);
          text-decoration: none;
        }
        
        .phone-link:hover {
          text-decoration: underline;
        }
      `}</style>
    </div>
    <Footer/>
    </>
  );
};

export default ReturnsExchangePage;